import { render, staticRenderFns } from "./BlogArticles.html?vue&type=template&id=854010d8&scoped=true&external"
import script from "./BlogArticles.vue?vue&type=script&lang=js"
export * from "./BlogArticles.vue?vue&type=script&lang=js"
import style0 from "./BlogArticles.scss?vue&type=style&index=0&id=854010d8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854010d8",
  null
  
)

export default component.exports